import { useMemo } from 'react';

import { getChartPalette } from 'components/charts/constants/chart-palettes';
import { useChartMode } from 'components/charts/hooks/use-chart-mode';
import { useOptionalChartSettings } from 'contexts/chart/chart-settings-context';
import { ChartPalette } from 'components/charts/types/chart-palette.type';

export const useChartPalette = (dark?: boolean): ChartPalette => {
  const mode = useChartMode(dark);
  const paletteOption = useOptionalChartSettings()?.settings.palette ?? 'verified';

  return useMemo(() => getChartPalette(mode, paletteOption), [mode, paletteOption]);
};
